import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=164d77dc&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"
import style0 from "./Dashboard.vue?vue&type=style&index=0&id=164d77dc&prod&scoped=true&lang=css"
import style1 from "./Dashboard.vue?vue&type=style&index=1&id=164d77dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164d77dc",
  null
  
)

export default component.exports